import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import { SidebarProvider } from "./context/SidebarContext";
import { TokenProvider } from "./context/TokenContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <SidebarProvider>
        <TokenProvider>
          <App />
        </TokenProvider>
      </SidebarProvider>
    </Provider>
  </React.StrictMode>,
);
